export default "__VITE_ASSET__d35ca2a6__"